export default defineNuxtRouteMiddleware(async (to) => {
    const sessionActive = await useAuthCheck();
    if (!sessionActive) {
        return navigateTo(`/auth/login?redirect=${to.fullPath}`)
    }
})